import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const seminoleHeightsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Seminole Heights Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Seminole Heights, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_seminole_heights',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Seminole Heights',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Seminole Heights Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take care of the tree work that 
     matters in <strong>Seminole Heights</strong>. This beloved Tampa neighborhood 
     is known for its craftsman bungalows and massive old oak canopy that gives 
     the streets their distinctive character. But those same mature oaks beautiful 
     as they are drop heavy limbs, develop structural cracks, and create serious 
     storm hazards when left unmanaged. Our team handles them with the care and 
     respect this neighborhood deserves.`,

    `We specialize in <strong>large oak trimming and hazardous tree removal in 
     historic residential settings</strong> overhanging limbs near bungalows 
     and carports, storm split canopies, root intrusion lifting driveways and 
     sidewalks, and precision removals that protect surrounding structures and 
     the character of your lot.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Seminole Heights</strong> and surrounding 
     <strong>Central Tampa</strong> neighborhoods keeping your home and 
     your beloved oaks safe and healthy for years to come.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Seminole Heights, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SeminoleHeights = () => <LocationPage config={seminoleHeightsConfig} />;
export default Services_SeminoleHeights;
